/* Studd Muffyn - Loose (fuzzy / typo-tolerant / benefit) search
   Enhances the /search results page AND the header quick-search dropdown:
   - When native search returns nothing, injects fuzzy results.
   - When native predictive search returns only a few, tops up with benefit/typo matches.
   Uses live /products.json + a benefit/problem map (ls-benefits.json). */

(function () {
  var loaded = false;

  function loadLooseSearch() {
    if (loaded) return;
    loaded = true;

    var s = document.createElement('script');
    s.src = "{{ 'loose-search.js' | asset_url }}";
    s.async = true;
    document.body.appendChild(s);
  }

  document.addEventListener('click', function(e) {
    if (
      e.target.closest('.header__search') ||
      e.target.closest('.search-modal') ||
      e.target.closest('details-modal') ||
      e.target.closest('[aria-controls*="Search"]') ||
      e.target.closest('[href*="/search"]')
    ) {
      loadLooseSearch();
    }
  }, true);

  document.addEventListener('focusin', function(e) {
    if (
      e.target.matches('input[type="search"]') ||
      e.target.matches('#Search-In-Modal') ||
      e.target.matches('.quick-search__input')
    ) {
      loadLooseSearch();
    }
  }, true);
})();
   
(function () {
  var FUSE_URL = 'https://cdn.jsdelivr.net/npm/fuse.js@7.0.0/dist/fuse.min.js';
  var idx = null, fuse = null, loadingIdx = false, fuseLoading = false, fuseCbs = [];
  var POP = {};

  function loadFuse(cb) {
    if (window.Fuse) return cb();
    if (fuseLoading) { fuseCbs.push(cb); return; }
    fuseLoading = true;
    var s = document.createElement('script');
    s.src = FUSE_URL;
    s.onload = function () { fuseLoading = false; cb(); fuseCbs.forEach(function (f) { f(); }); fuseCbs = []; };
    s.onerror = function () { fuseLoading = false; };
    document.head.appendChild(s);
  }

  function strip(html) { return String(html || '').replace(/<[^>]*>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' ').trim().slice(0, 700); }

  function getIndex(cb) {
    if (idx) return cb(idx);
    try { var c = sessionStorage.getItem('ls_idx3'); if (c) { idx = JSON.parse(c); return cb(idx); } } catch (e) {}
    if (loadingIdx) { setTimeout(function () { getIndex(cb); }, 400); return; }
    loadingIdx = true;
    var all = [], page = 1;
    (function next() {
      fetch('/products.json?limit=250&page=' + page)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var it = d.products || [];
          all = all.concat(it);
          if (it.length === 250 && page < 10) { page++; next(); }
          else {
            var built = all.map(function (p) {
              return {
                t: p.title, h: p.handle,
                g: (p.tags || []).join(' '),
                y: p.product_type || '', v: p.vendor || '',
                img: (p.images && p.images[0] ? p.images[0].src : ''),
                pr: (p.variants && p.variants[0] ? p.variants[0].price : ''),
                d: strip(p.body_html)
              };
            });
            var finish = function () {
              idx = built;
              try { sessionStorage.setItem('ls_idx3', JSON.stringify(idx)); } catch (e) {}
              loadingIdx = false; cb(idx);
            };
            var burl = window.LS_BEN_URL;
            if (burl) {
              fetch(burl).then(function (r) { return r.ok ? r.json() : {}; }).then(function (ben) {
                built.forEach(function (it) { if (ben[it.h]) { it.d = (it.d + ' ' + ben[it.h]).slice(0, 950); } });
                finish();
              }).catch(finish);
            } else { finish(); }
          }
        }).catch(function () { loadingIdx = false; cb(all); });
    })();
  }

  function getFuse(cb) {
    loadFuse(function () {
      getIndex(function (items) {
        if (!fuse) {
          fuse = new Fuse(items, {
            keys: [{ name: 't', weight: 0.5 }, { name: 'g', weight: 0.2 }, { name: 'd', weight: 0.2 }, { name: 'y', weight: 0.06 }, { name: 'v', weight: 0.04 }],
            threshold: 0.44, ignoreLocation: true, minMatchCharLength: 2, distance: 120, includeScore: true
          });
        }
        cb(fuse);
      });
    });
  }

  var SYN = {
    'gm': 'am pm', 'gmpm': 'am pm', 'gm pm': 'am pm', 'am gm': 'am pm', 'ampm': 'am pm',
    'pgm': 'pigmentation', 'pigment': 'pigmentation', 'pgmntation': 'pigmentation', 'pigmentaion': 'pigmentation', 'pigmntation': 'pigmentation',
    'hairfall': 'hair fall', 'hair fal': 'hair fall',
    'antiaging': 'anti aging', 'anti-aging': 'anti aging', 'antiageing': 'anti aging', 'anti age': 'anti aging',
    'darkspot': 'dark spots', 'darkspots': 'dark spots', 'dark spot': 'dark spots',
    'weightloss': 'stubborn fat', 'weight loss': 'stubborn fat', 'fatloss': 'stubborn fat', 'fat loss': 'stubborn fat', 'bellyfat': 'stubborn fat', 'belly fat': 'stubborn fat',
    'dandruf': 'dandruff', 'detan': 'tan', 'de tan': 'tan'
  };
  function normTitle(t) { return String(t || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function normQ(q) { var n = normTitle(q); return SYN[n] || n; }
  function search(q, limit, cb) {
    getFuse(function (f) {
      var res = f.search(normQ(q));
      res.forEach(function (x) { var pf = POP[normTitle(x.item.t)] || 0; x._s = (x.score == null ? 0 : x.score) - 0.15 * pf; });
      res.sort(function (a, b) { return a._s - b._s; });
      cb(res.slice(0, limit || 8).map(function (x) { return x.item; }));
    });
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function card(it, big) {
    var a = document.createElement('a');
    a.href = '/products/' + it.h;
    a.style.cssText = 'text-decoration:none;color:inherit;display:block;';
    var img = it.img ? '<img src="' + it.img + '" loading="lazy" style="width:100%;aspect-ratio:1;object-fit:cover;border-radius:10px;display:block;">' : '';
    var fs = big ? '13px' : '12px';
    a.innerHTML = img +
      '<div style="margin-top:7px;font-size:' + fs + ';line-height:1.35;">' + esc(it.t) + '</div>' +
      (it.pr ? '<div style="margin-top:3px;font-size:' + fs + ';font-weight:600;">₹' + it.pr + '</div>' : '');
    return a;
  }

  /* ---------- 1) Full /search results page fallback ---------- */
  function initPage() {
    if (location.pathname.indexOf('/search') !== 0) return;
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    if (!q) return;
    var txt = (document.body.innerText || '').toLowerCase();
    var empty = /no results|0 results|check the spelling|couldn.t find|no products|didn.t match/.test(txt);
    var links = document.querySelectorAll('#main a[href*="/products/"]');
    if (!empty && links.length >= 2) return;
    if (document.getElementById('ls-fb')) return;
    search(q, 24, function (res) {
      if (!res.length || document.getElementById('ls-fb')) return;
      var w = document.createElement('div'); w.id = 'ls-fb';
      w.style.cssText = 'max-width:1200px;margin:24px auto 48px;padding:0 20px;font-family:inherit;';
      var h = document.createElement('h2');
      h.textContent = 'Showing closest matches for “' + q + '”';
      h.style.cssText = 'font-size:20px;font-weight:600;margin:0 0 18px;text-align:center;';
      w.appendChild(h);
      var g = document.createElement('div');
      g.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:18px;';
      res.forEach(function (it) { g.appendChild(card(it, true)); });
      w.appendChild(g);
      (document.getElementById('main') || document.body).appendChild(w);
    });
  }

  /* ---------- 2) Header quick-search dropdown lead-with-ours ---------- */
  var SHOW_SEL = ['.quick-search__active-search-container', '.quick-search__results-wrapper', '.quick-search__results'];
  function ensureStyle() {
    if (document.getElementById('ls-style')) return;
    var st = document.createElement('style'); st.id = 'ls-style';
    st.textContent = '.ls-show{visibility:visible !important;opacity:1 !important;pointer-events:auto !important;}' + 'body:has(.ls-dd) .quick-search__no-results-header,body:has(.ls-dd) .quick-search__no-results,body:has(.ls-dd) [class*="no-result"]{display:none !important;}' + '.quick-search__results:has(.ls-dd) > *:not(.ls-dd){display:none !important;}';
    document.head.appendChild(st);
  }
  function showChain(on) {
    SHOW_SEL.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (e) { e.classList[on ? 'add' : 'remove']('ls-show'); });
    });
  }
  function removeDD() { document.querySelectorAll('.ls-dd').forEach(function (e) { e.remove(); }); showChain(false); }

  function activeInput() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('.quick-search__input'));
    if (!inputs.length) return null;
    var ae = document.activeElement, i;
    for (i = 0; i < inputs.length; i++) { if (inputs[i] === ae) return inputs[i]; }
    var withVal = null, visible = null;
    inputs.forEach(function (inp) { if (inp.offsetParent !== null) { if (!visible) visible = inp; if (inp.value.trim() && !withVal) withVal = inp; } });
    return withVal || visible || inputs[0];
  }
  function resultsFor(inp) { if (!inp) return null; var c = inp.closest('.quick-search__active-search-container') || inp.closest('[data-quick-search]') || document; return c.querySelector('.quick-search__results'); }
  function curQ() { var i = activeInput(); return i ? i.value.trim() : ''; }
  var lastQ = '';

  function buildCol(items, title) {
    var col = document.createElement('div');
    col.className = 'ls-dd';
    col.style.cssText = 'flex:1 1 auto;min-width:0;padding:10px 14px;';
    var h = document.createElement('div');
    h.textContent = title || 'Products';
    h.style.cssText = 'font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#8a8a8a;margin:0 0 12px;';
    col.appendChild(h);
    var grid = document.createElement('div');
    grid.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:14px;';
    items.forEach(function (it) { grid.appendChild(card(it, false)); });
    col.appendChild(grid);
    return col;
  }

  function maybeInject() {
    var inp = activeInput();
    var q = inp ? inp.value.trim() : '';
    var res = resultsFor(inp);
    if (!res || q.length < 2) { removeDD(); lastQ = ''; return; }
    if (document.querySelector('.ls-dd') && lastQ === q) return;
    lastQ = q;
    search(q, 10, function (items) {
      var inp2 = activeInput();
      if (!inp2 || inp2.value.trim() !== q) return;
      var r2 = resultsFor(inp2);
      if (!r2) { removeDD(); return; }
      if (!items.length) { removeDD(); return; }
      removeDD();
      var col = buildCol(items.slice(0, 8), 'Products');
      if (r2.firstChild) { r2.insertBefore(col, r2.firstChild); } else { r2.appendChild(col); }
      ensureStyle();
      showChain(true);
    });
  }

  var mtimer;
  function schedule() { clearTimeout(mtimer); mtimer = setTimeout(maybeInject, 180); }

  function bindInputs() {
    document.querySelectorAll('.quick-search__input').forEach(function (inp) {
      if (inp.__ls) return; inp.__ls = true;
      inp.addEventListener('input', schedule);
      inp.addEventListener('focus', schedule);
      inp.addEventListener('blur', function () {
        setTimeout(function () { if (document.activeElement !== inp) { removeDD(); lastQ = ''; } }, 220);
      });
    });
    document.querySelectorAll('.quick-search__active-search-container').forEach(function (t) {
      if (t.__lsobs) return; t.__lsobs = true;
      var obs = new MutationObserver(schedule); obs.observe(t, { childList: true, subtree: true });
    });
  }

  var popLoaded = false;
  function loadPopularity() {
    if (popLoaded) return;
    var purl = window.LS_POP_URL; if (!purl) return;
    popLoaded = true;
    fetch(purl).then(function (r) { return r.ok ? r.json() : []; }).then(function (arr) {
      if (arr && arr.length) { var n = arr.length; arr.forEach(function (t, i) { POP[normTitle(t)] = (n - i) / n; }); }
    }).catch(function () { popLoaded = false; });
  }

  function boot() {
    loadPopularity();
    initPage();
    bindInputs();
    try {
      var mo = new MutationObserver(function () { bindInputs(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
